import type { SVGProps } from 'react';

export function BoomboxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 2a3 3 0 0 1 3 3v3.174c1.165.412 2 1.52 2 2.826v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-8c0-1.306.835-2.414 2-2.826V5a3 3 0 0 1 3-3zM7.5 12a3 3 0 1 0 0 6 3 3 0 0 0 0-6m9 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6M6 4a1 1 0 0 0-1 1v3h2a1 1 0 0 1 2 0h2a1 1 0 1 1 2 0h2a1 1 0 1 1 2 0h2V5a1 1 0 0 0-1-1z" />
    </svg>
  );
}
